const ArrowRight = ({ height = 8, width = 4 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 4 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.135162 7.84719C-0.045054 7.64343 -0.0450541 7.31309 0.135162 7.10933L2.88576 4L0.135162 0.890671C-0.0450543 0.686914 -0.0450544 0.356549 0.135162 0.152792C0.315409 -0.05093 0.607656 -0.05093 0.787903 0.152792L3.86484 3.63106C4.04505 3.83481 4.04505 4.16518 3.86484 4.36893L0.787903 7.84719C0.607657 8.05094 0.315409 8.05094 0.135162 7.84719Z"
        fill="#414141"
      />
    </svg>
  );
};

export default ArrowRight;
